var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconIosSchool = function SvgIconIosSchool(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.715,
    height: 30.609,
    viewBox: "0 0 35.715 30.609",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-school",
    "data-name": "Icon ionic-ios-school",
    transform: "translate(-2.317 -4.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M6.813,19.081v7.389a.646.646,0,0,0,.319.558l10.522,6.05a.639.639,0,0,0,.957-.558V25.044a.646.646,0,0,0-.319-.558L7.77,18.515A.649.649,0,0,0,6.813,19.081Z",
    transform: "translate(0.601 1.873)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M19.863,33.088l10.53-6.05a.636.636,0,0,0,.319-.558V19.011a.64.64,0,0,0-.957-.558L19.233,24.5a.636.636,0,0,0-.319.558v7.477A.631.631,0,0,0,19.863,33.088Z",
    transform: "translate(2.219 1.864)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M19.539,4.6,2.64,14.465a.637.637,0,0,0,0,1.108l16.9,9.39a1.283,1.283,0,0,0,1.267,0L35.8,16.379c.422-.247.558.064.558.558V29.164c0,.542.311.8.877.8h0a.786.786,0,0,0,.8-.8V15.47a.646.646,0,0,0-.319-.558L20.806,4.6A1.283,1.283,0,0,0,19.539,4.6Z",
    transform: "translate(0)",
    fill: "#f6c866"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconIosSchool, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-ios-school.5fc3680a.svg";
export { ForwardRef as ReactComponent };